<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div class="dw-wo-status-body" :class="{ 'dw-wo-status-body--empty': !hasAny }">
            <div v-if="!hasAny" class="dw-wo-status-empty">
                <div class="dw-wo-status-empty-icon"><i class="bi bi-clipboard-data"></i></div>
                <div class="dw-wo-status-empty-text">{{ $t('common.dashboard.widgetEmpty.workOrderStatusTitle') }}</div>
                <div class="dw-wo-status-empty-sub">{{ $t('common.dashboard.widgetEmpty.workOrderStatusSub') }}</div>
            </div>
            <template v-else>
                <div class="dw-wo-status-cards">
                    <div class="dw-wo-scard" v-for="s in items" :key="s.status_id">
                        <div class="dw-wo-scard-icon" :style="{ background: styleFor(s.status_id).bg, color: styleFor(s.status_id).color }">
                            <i :class="['bi', styleFor(s.status_id).icon]"></i>
                        </div>
                        <div class="dw-wo-scard-info">
                            <span class="dw-wo-scard-num" :style="{ color: styleFor(s.status_id).color }">{{ s.count }}</span>
                            <span class="dw-wo-scard-lbl">{{ s.label }}</span>
                        </div>
                    </div>
                </div>
                <div class="dw-wo-summary-section">
                    <span class="dw-wo-summary-title">{{ $t('common.dashboard.widgetLabels.workOrderDistribution') }}</span>
                    <div class="dw-summary-bar">
                        <div v-for="s in items" :key="s.status_id" class="dw-summary-seg" :style="{ flex: s.count || 0, background: styleFor(s.status_id).color }">
                            <span class="dw-summary-tooltip">{{ s.label }}: {{ s.count }}</span>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';

export const meta = {
    id: 'work_order_status',
    titleKey: 'common.dashboard.widgetTitles.work_order_status',
    icon: 'bi-clipboard-data',
    accent: '#3B82F6',
    accentBg: 'rgba(59, 130, 246, 0.12)',
    glassRgb: '59, 130, 246',
    defaultCol: 2,
    defaultRow: 1,
    source: { type: 'module', moduleCode: 'VEHICLE_WORK_ORDER', code: 'STATUS_SUMMARY' },
};

const STATUS_STYLE = {
    1: { icon: 'bi-hourglass-split', color: 'var(--bs-warning)', bg: 'rgba(var(--bs-warning-rgb, 255, 199, 0), 0.12)' },
    2: { icon: 'bi-gear-wide-connected', color: 'var(--bs-info)', bg: 'rgba(var(--bs-info-rgb, 114, 57, 234), 0.12)' },
    3: { icon: 'bi-check-circle', color: 'var(--bs-success)', bg: 'rgba(var(--bs-success-rgb, 80, 205, 137), 0.12)' },
    4: { icon: 'bi-truck', color: '#3B82F6', bg: 'rgba(59, 130, 246, 0.12)' },
    5: { icon: 'bi-x-circle', color: 'var(--bs-danger)', bg: 'rgba(var(--bs-danger-rgb, 241, 65, 108), 0.12)' },
    6: { icon: 'bi-arrow-counterclockwise', color: 'var(--bs-gray-600)', bg: 'rgba(var(--bs-secondary-rgb, 108, 117, 125), 0.12)' },
};

const FALLBACK_STYLE = { icon: 'bi-circle', color: 'var(--bs-gray-500)', bg: 'rgba(var(--bs-secondary-rgb, 108, 117, 125), 0.10)' };

export default {
    name: 'WorkOrderStatusWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return { meta };
    },
    computed: {
        items() {
            return this.apiData?.items || [];
        },
        hasAny() {
            return this.items.some(i => (parseInt(i.count, 10) || 0) > 0);
        },
    },
    methods: {
        styleFor(statusId) {
            return STATUS_STYLE[statusId] || FALLBACK_STYLE;
        },
    },
};
</script>

<style>
.dw-wo-status-body--empty { align-items: center; justify-content: center; }
.dw-wo-status-empty {
    flex: 1;
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    gap: 8px; text-align: center;
    padding: 8px 12px;
}
.dw-wo-status-empty-icon {
    width: 56px; height: 56px;
    border-radius: 16px;
    display: flex; align-items: center; justify-content: center;
    background: rgba(59, 130, 246, 0.10);
    color: #3B82F6;
    margin-bottom: 4px;
}
.dw-wo-status-empty-icon .bi { font-size: 26px; }
.dw-wo-status-empty-text {
    font-size: 13px; font-weight: 600;
    color: var(--bs-body-color);
}
.dw-wo-status-empty-sub {
    font-size: 11px; color: var(--bs-gray-500);
    line-height: 1.4; max-width: 220px;
}
</style>
